import { p as packageJson } from './package.js';
import { c as config } from './config.js';
import { A as Api } from './Api.js';

class AnalyticsService {
    async record(body) {
        const endpoint = 'analytics';
        return Api({ apiOrigin: config.proxyApiOrigin }).post(endpoint, body);
    }
}

/**
 * @class JustifiAnalytics
 * @description A class to track analytics for a component
 * @param { component } ComponentInterface - The component to track
 *
 */
class JustifiAnalytics {
    constructor(component) {
        this.handleCustomEvent = async (data) => {
            // Track the event
            await this.service.record(data);
        };
        this.service = new AnalyticsService();
        this.componentInstance = component;
        this.setUpBasicData();
        this.setupLifecycleTracking();
        this.trackCustomEvents();
    }
    get resourceId() {
        return (this.componentInstance.accountId ||
            this.componentInstance.businessId ||
            this.componentInstance.paymentId ||
            this.componentInstance.payoutId ||
            this.componentInstance.checkoutId);
    }
    setUpBasicData() {
        this.basicData = {
            component_name: this.componentInstance.tagName,
            component_version: packageJson.version,
            client_user_agent: navigator.userAgent,
            // navigator.platform is deprecated, use navigator.userAgent instead
            client_platform: navigator.userAgent,
            client_origin: window.location.origin,
            resource_id: this.resourceId,
        };
    }
    trackCustomEvents() {
        this.eventEmitters = ['submitted', 'error-event'];
        // for each event, add an event listener
        this.eventEmitters.forEach((eventName) => {
            // if this.componentInstance.addEventListener is a function add the event listener
            if (typeof this.componentInstance.addEventListener === 'function') {
                this.componentInstance.addEventListener(eventName, (event) => this.handleCustomEvent({
                    event_type: eventName,
                    data: Object.assign(Object.assign({}, this.basicData), { error: event.detail }),
                }));
            }
        });
    }
    setupLifecycleTracking() {
        const originalComponentDidLoad = this.componentInstance.componentDidLoad;
        this.componentInstance.componentDidLoad = () => {
            this.service.record({ event_type: 'init', data: this.basicData });
            if (originalComponentDidLoad) {
                return originalComponentDidLoad.apply(this.componentInstance);
            }
        };
    }
    cleanup() {
        // Remove event listeners
        this.eventEmitters.forEach((event) => {
            this.componentInstance.removeEventListener(event, this.handleCustomEvent);
        });
    }
}

export { JustifiAnalytics as J };
